export default "__VITE_ASSET__CSjJNqBp__"